<template>
  <div class="main-box patient-list-box" v-loader.opacity="loading">
    <div class="">
      <div class="title-box clear">
        <h2 class="title">{{ $t('patient.patientList') }}</h2>

        <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnNewPatient" v-if="!isSpecialist" @click="newPatient">
          <IconPlus/>
          <span>{{ $t('patient.create') }}</span>
        </button>

        <v-select
          class="v-select v-select-themed ffs-filter"
          v-model="ffsFilter"
          :options="ffsFilterOptions"
          :reduce="x => x.value"
          :clearable="false"
          :searchable="false"
          :aria-label="$t('ffsFilter.label')"
          data-test="vSelectFfsFilter"
          @option:selected="onFfsFilterChange">
        </v-select>
      </div>

      <div v-if="tablePatient && !alert.message" class="align-items-center page-row">
        <p class="pagination-total">{{ `${tablePatient.total} ${$t("pagination.patients")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tablePatient.total"
                          :per-page="perPage" :current-page="currentPage" @pagechanged="onPageChange"/>
      </div>
    </div>


    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <BaseTable id="patientList" class="no-border" v-if="tablePatient" :tabledata="tablePatient" @item-opened="toDetails">
      <template v-slot:column_name="{item}">
        <span>{{ item.rawName }}</span>
        <BaseFfsBadge v-if="item.ffs"/>
      </template>
    </BaseTable>

    <BaseGenericOffcanvas :offcanvas_id="'offcanvasPatientGeneric'" ref="offcanvasGeneric"/>
  </div>
</template>

<style lang="scss" scoped>
.title-box {
  justify-content:                  flex-start !important;
  gap:                              10px;
  margin:                           0;
  padding:                          0;
}

.ffs-filter {
  min-width:                        190px;
  margin-left:                      auto;
}

.table {
  margin-bottom:                    0 !important;
}

.patient-list-box {
  > div {
    &:first-child {
      display:                      flex;
      align-items:                  center;
      justify-content:              space-between;
      padding:                      15px 20px;
    }
  }
}

@media (max-width: 991px) {
  .patient-list-box {
    display:                        flex;
    flex-direction:                 column;

    .no-results-box {
      text-align:                   center;
    }
  }

  .title-box {
    display:                        flex !important;
    justify-content:                flex-start !important;
    gap:                            10px;
    flex:                           1;
    margin-bottom:                  0 !important;

    .btn-outline-secondary {
      height:                       35px;
      padding:                      10px 12px;

      span {
        display:                    none;
      }
    }

    .title {
      font-size:                    18px !important;
      text-align:                   left;
      // width:                        calc(100% - 44px) !important;
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'

export default {
  name: 'patient-list',
  data: () => ({
    loading: false,
    alert: {
      title: null,
      message: null,
      class: null
    },
    session: {
      collaborator: {},
      currentClinic: {}
    },
    tablePatient: null,
    perPage: 20,
    currentPage: 1,
    totalPages: 0,
    search: null,
    patientList: {
      items: [],
      total: 0,
      columns: []
    },
    items: {},
    mergedItems: {},
    isSpecialist: null,
    ffsFilter: 'all',
  }),
  computed: {
    isSpecialist() {
      return this.session.permissions === 'specialist'
    },
    ffsFilterOptions() {
      return [
        {value: 'all', label: this.$i18n.t('ffsFilter.all')},
        {value: 'ffs', label: this.$i18n.t('ffsFilter.ffs')},
        {value: 'nonFfs', label: this.$i18n.t('ffsFilter.nonFfs')},
      ]
    }
  },
  mounted() {
    this.$activeLink.value = 'patient'
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    this.isSpecialist = this.session.isSpecialist
    this.currentPage = this.session.patientCurrentPage ? this.session.patientCurrentPage : 1;
    this.ffsFilter = this.session.patientFfsFilter ? this.session.patientFfsFilter : 'all';
    this.fetchData()
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.session.patientCurrentPage = page;
      this.fetchData();
    },
    onFfsFilterChange() {
      this.session.patientFfsFilter = this.ffsFilter;
      this.onPageChange(1);
    },
    async fetchData() {
      this.alert = {}

      let params = {
        page: this.currentPage,
        ffsFilter: this.ffsFilter
      }
      if (this.search)
        params.q = this.search

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$patientService.getList(params)

        this.tablePatient = {
          'items': response.result,
          'total': response.totalCount,
          'columns': [
            {key: 'name', name: this.$i18n.t('patient.name'), type: 'string', value: 'rawName', width: '34%'},
            {name: this.$i18n.t('patient.mrn'), type: 'string', value: 'mrn', width: '33%'},
            // {name: this.$i18n.t('document0'), type: 'string', value: 'document0', width: '33%'}
          ]
        }

        if (!this.isSpecialist)
          this.tablePatient.columns.push({name: this.$i18n.t('document0'), type: 'string', value: 'document0', width: '33%'});

        this.totalPages = Math.ceil(response.totalCount / this.perPage);

        if (response.result.length === 0) {
          this.tablePatient = {};
          this.totalPages = 1
          this.alert = this.$message.alertWithTitle(this, 'request_notfound_patient_title', 'request_notfound_patient_text')
          // this.$message.popup(this, 'request_notfound', 'operationWarning', 'warn')
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    async newPatient() {
        this.$router.push({name: 'patient-create', params: {patientID: ''}})
    },
    toDetails(values) {
      if (!values) {
        return
      }

      let item = values.item

      if (!item) {
        return
      }

      this.$router.push({name: 'patient-show', params: {patientID: item.id}, query: {tab: 'data'}})
    },
  },
  // unmounted() {
  //   this.session = null
  // }
}
</script>
